// extracted by mini-css-extract-plugin
export default {"wrapper":"Task_wrapper__yjetS"};